import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Justify } from "../justify";
import { useConfig } from "../_util/config-context";
export var CalendarPanel = React.forwardRef(function CalendarPanel(_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.rangeMode, rangeMode = _c === void 0 ? false : _c, _d = _a.timeMode, timeMode = _d === void 0 ? false : _d, props = __rest(_a, ["className", "children", "rangeMode", "timeMode"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-calendar", className, (_b = {},
            _b[classPrefix + "-calendar--date-range"] = rangeMode,
            _b[classPrefix + "-calendar--time"] = timeMode,
            _b)) }, props), children));
});
CalendarPanel.displayName = "CalendarPanel";
export function CalendarHeader(_a) {
    var style = _a.style, className = _a.className, children = _a.children;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", { className: classNames(classPrefix + "-calendar__header", className), style: style }, children));
}
CalendarHeader.displayName = "CalendarHeader";
export function CalendarBody(_a) {
    var style = _a.style, className = _a.className, children = _a.children;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", { className: classNames(classPrefix + "-calendar__body", className), style: style }, children));
}
CalendarBody.displayName = "CalendarBody";
export function CalendarFooter(_a) {
    var style = _a.style, className = _a.className, left = _a.left, right = _a.right;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", { className: classNames(classPrefix + "-calendar__footer", className), style: style },
        React.createElement(Justify, { left: left, right: right })));
}
CalendarFooter.displayName = "CalendarFooter";
export default {
    Panel: CalendarPanel,
    Header: CalendarHeader,
    Body: CalendarBody,
    Footer: CalendarFooter,
};
//# sourceMappingURL=CalendarPart.js.map